import '@angular/localize/init';
import {
  BasketManagerFilterQuery,
  BasketManagerFilterValues,
} from 'graphql-api/gql-api-interfaces';

export const CONFIRM_DELETION_MESSAGE = $localize`:@@basketManagerDeletionConfirmationModalMessage:Are you sure you want to delete 1 basket?`;
export const CONFIRM_DELETION_MESSAGE_PLURAL = (selectedBasketCount: number) =>
  $localize`:@@basketManagerDeletionConfirmationModalMessagePlural:Are you sure you want to delete ${selectedBasketCount} baskets?`;

export const CONFIRM_DELETION_TITLE = $localize`:@@basketManagerDeletionConfirmationModalTitle:Delete basket`;
export const CONFIRM_DELETION_TITLE_PLURAL = $localize`:@@basketManagerDeletionConfirmationModalTitlePlural:Delete baskets`;

export const CONFIRM_DOWNLOAD_MESSAGE = $localize`:@@basketManagerDownloadConfirmationModalMessage:Are you sure you want to download 1 basket?`;
export const CONFIRM_DOWNLOAD_MESSAGE_PLURAL = (selectedBasketCount: number) =>
  $localize`:@@basketManagerDownloadConfirmationModalMessagePlural:Are you sure you want to download ${selectedBasketCount} baskets?`;

export const CONFIRM_DOWNLOAD_TITLE = $localize`:@@basketManagerDownloadConfirmationModalTitle:Download basket`;
export const CONFIRM_DOWNLOAD_TITLE_PLURAL = $localize`:@@basketManagerDownloadConfirmationModalTitlePlural:Download baskets`;

export const CONFIRM_RESEND_CONFIRMATION_MESSAGE = $localize`:@@basketManagerResendConfirmationModalMessage:Are you sure you want to resend confirmation for 1 basket?`;
export const CONFIRM_RESEND_CONFIRMATION_MESSAGE_PLURAL = (
  selectedBasketCount: number,
) =>
  $localize`:@@basketManagerResendConfirmationModalMessagePlural:Are you sure you want to resend confirmation for ${selectedBasketCount} baskets?`;

export const CONFIRM_RESEND_CONFIRMATION_TITLE = $localize`:@@basketManagerResendConfirmationModalTitle:Resend confirmation for basket`;
export const CONFIRM_RESEND_CONFIRMATION_TITLE_PLURAL = $localize`:@@basketManagerResendConfirmationModalTitlePlural:Resend confirmation for baskets`;

export const basketManagerFeatureKey = 'basket-manager';

export enum BasketManagerFilterProps {
  Accounts = 'Accounts',
  OrderType = 'OrderType',
  Brand = 'Brand',
  DatesRange = 'DatesRange',
  Status = 'Status',
  User = 'User',
  Search = 'Search',
  Assignee = 'Assignee',
}

export interface State {
  currentFilters: BasketManagerFilterQuery;
  multipleFilters: BasketManagerFilterProps[];
  filters: BasketManagerFilterValues;
  loading: boolean;
  userFilterQuery: string;
  accountFilterQuery: string;
}

export const basketManagerFiltersFeatureKey = 'filters';

const keys: (keyof State)[] = ['currentFilters'];

export const storageKeys = keys.map(
  (key) => `${basketManagerFiltersFeatureKey}.${key}`,
);
